document.addEventListener('DOMContentLoaded',function(){
  document.querySelectorAll('[data-menu-toggle]').forEach(function(btn){
    btn.addEventListener('click',function(){
      var nav=document.querySelector('[data-mobile-nav]');
      if(nav){nav.classList.toggle('is-open');}
    });
  });
  document.querySelectorAll('[data-qty-minus],[data-qty-plus]').forEach(function(btn){
    btn.addEventListener('click',function(){
      var input=btn.parentElement.querySelector('input');
      if(!input)return;
      var n=parseInt(input.value||'1',10);
      input.value=btn.hasAttribute('data-qty-plus')?n+1:Math.max(1,n-1);
    });
  });
});
